export default {
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getSearchFields: state => state.searchFields,
    getHeaderFields: state => state.headerFields,
    getFormFields: state => state.formFields,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,

    getHeaderFieldsDrugEquiv: state => state.headerFieldsDrugEquiv,

    getTamalapHeaderFields: state => state.tamalapHeaderFields,
    getTamalapRowActions: state => state.tamalapRowActions,

    getKategtamHeaderFields: state => state.kategtamHeaderFields,
    getKategtamRowActions: state => state.kategtamRowActions,

    getEupontokHeaderFields: state => state.eupontokHeaderFields,
    getEupontokRowActions: state => state.eupontokRowActions,

    getBnokodokHeaderFields: state => state.bnokodokHeaderFields,

    getEujoghozzarHeaderFields: state => state.eujoghozzarHeaderFields
}
